<template>
    <div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="orders-o"/>
                        订单基本信息
                    </h5>
                </van-col>
                <van-col span="12">
                    <p class="text-right red">{{orders.orderStatusName}}</p>
                </van-col>
            </van-row>
            <div class="item-body-warp" :class="{'open':isOpen1}">
                <van-row>
                    <van-col span="24">
                        <p><span>订单编号</span>
                            <span class="red" v-if="orders.isPartOut==1">{{orders.orderId}}</span>
                            <span v-else>{{orders.orderId}}</span>
                        </p>
                    </van-col>
                    <van-col span="24" v-if="orders.orderStatus==45">
                        <p><span>退货原因</span>
                            <span>{{data.refundReason}}</span>
                        </p>
                    </van-col>

                </van-row>

                <van-row>
                    <van-col span="24">
                        <!-- <p><span>审核状态</span>{{orders.checkStatus == 0?'':'待'+order.roleDealName+'审核'}}</p> -->
                        <p v-if="workFlow.status == 0">
                            <span>审核状态</span>待{{curdata.roleDealName}}审核
                        </p>
                        <p v-else-if="workFlow.status == 1">
                            <span>审核状态</span>已通过
                        </p>
                        <p v-else>
                            <span>审核状态</span>已驳回
                        </p>
                        <p><span>期望到货时间</span>{{orders.expectedArrivalTime == null?'':orders.expectedArrivalTime}}</p>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <p><span>是否已到货</span>{{orders.isReach == 0?'否':'是（' +orders.reachTime+')'}}</p>
                    </van-col>
                    <van-col span="24">
                        <!-- <p><span>是否分批出库</span>{{orders.isPartOut == 1? '是': '否'}}</p> -->
                        <p v-if="orders.isPartOut == 0">
                            <span>是否分批出库</span>否
                            <!-- <a href="">查看出库单</a>-->
                        </p>
                        <p v-else>
                            <span>是否分批出库</span>是
                        </p>
                    </van-col>
                    <van-col span="24">
                        <p><span>是否财务审核</span>{{orders.needFm == 1? '是': '否'}}</p>
                    </van-col>
                </van-row>
                <b class="line"></b>
                <van-row>
                    <van-col span="24">
                        <p><span>总价</span>￥{{orders.totalPrice}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>生成时间</span>{{orders.createtime}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>发货时间</span>{{orders.shipTime}}</p>
                    </van-col>
                    <van-col span="24">
                        <p class=""><span>配送方式</span>{{orders.transport ==''?'物流配送':orders.transport}}</p>
                    </van-col>
                    <van-col span="12">
                        <p><span>货物总价</span>￥{{orders.goodsAmount}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>运费</span>￥{{orders.shipPrice}}</p>
                    </van-col>
                    <van-col span="12">
                        <p><span>折扣金额</span>￥{{orders.payDiscountAmount + orders.fullDiscountAmount}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>订单总价</span>￥{{orders.totalPrice}}</p>
                    </van-col>
                    <van-col span="12">
                        <p><span>成交价格</span>￥{{orders.realPrice}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>应付金额</span>￥{{orders.shouldPayPrice}}</p>
                    </van-col>


                    <van-col span="12">
                        <p><span>积分抵扣金额</span>￥{{orders.usePointAmount}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>抵扣积分数</span>{{orders.usePoint}}</p>
                    </van-col>

                    <van-col span="12">
                        <p><span>订单赠送积分</span>{{data.orderPoint}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>活动商品赠送积分</span>{{data.activityPoint}}</p>
                    </van-col>

                    <van-col span="12">
                        <p><span>折扣总金额</span>￥{{orders.fullDiscountAmount+orders.payDiscountAmount}}</p>
                    </van-col>

                </van-row>
            </div>
            <p class="item-arrow" @click="showOpen1(1)">{{openText1}}
                <van-icon :name="openIcon1"/>
            </p>
        </div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="user-o" class="bg-green"/>
                        会员信息
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>
            <div class="item-body-warp" :class="{'open':isOpen2}">
                <van-row>
                    <van-col span="14">
                        <p><span>用户名</span>{{appUsers.userName}}</p>
                    </van-col>
                    <van-col span="10">
                        <p class="text-right"><span>用户类型</span>{{appUsers.user_type_name}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>牧场名称</span>{{appUsers.mcmc}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class=""><span>牧场编号</span>{{appUsers.pastureID}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>真实姓名</span>{{appUsers.trueName}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class=""><span>手机号</span>{{appUsers.mobile}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>所属公司</span>{{appUsers.org_name}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>所属片区</span>{{appUsers.org_area}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>所在地</span>{{appUsers.area_path +' '+ appUsers.address}}</p>
                    </van-col>
                </van-row>
            </div>
            <!-- <p class="item-arrow" @click="showOpen1()">展开<van-icon name="arrow-down"/></p> -->
            <p class="item-arrow" @click="showOpen1(2)">{{openText2}}
                <van-icon :name="openIcon2"/>
            </p>
        </div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="orders-o" class="bg-cyan"/>
                        收货地址
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>
            <van-row>
                <van-col span="14">
                    <p><span>收货人</span>{{appUsers.consigneeName}}</p>
                </van-col>
                <van-col span="24">
                    <p><span>收货人手机</span>{{appUsers.consigneeMobile}}</p>
                </van-col>
                <van-col span="24">
                    <p><span>收货地址</span>{{appUsers.consigneeArea_path + appUsers.consigneeAreaInfo}}</p>
                </van-col>
            </van-row>
        </div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="logistics" class="bg-indigo"/>
                        货运信息
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>
            <div class="item-body-warp" :class="{'open':isOpen3}">
                <van-row>
                    <van-col span="24">
                        <!-- <p><span>车次类型</span>{{orders.trainType == 1? '专车': ''}}</p> -->
                        <p v-if="orders.trainType == 1">
                            <span>车次类型</span>专车
                        </p>
                        <p v-else-if="orders.trainType == 2">
                            <span>车次类型</span>拼车
                        </p>
                        <p v-else>
                            <span>车次类型</span>
                        </p>
                    </van-col>
                    <van-col span="24">
                        <p class=""><span>车牌号</span>{{orders.plateNo == null? '': orders.plateNo}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>发车时间</span>{{orders.departureTime==null?'':orders.departureTime}}</p>
                    </van-col>

                    <van-col span="24">
                        <p><span>司机姓名</span>{{orders.driverName==null?'':orders.driverName}}</p>
                    </van-col>
                    <van-col span="24">
                        <p><span>司机身份证号</span>{{orders.driverIdnumber==null?'':orders.driverIdnumber}}</p>
                    </van-col>

                    <van-col span="24">
                        <p class=""><span>手机号</span>{{orders.mobileDriver==null?'':orders.mobileDriver}}</p>
                    </van-col>
                    <!--<van-col span="24">
                        <p><span>到货时间</span>{{orders.isReach == 0?'':orders.reachTime}}</p>
                    </van-col>-->
                    <van-col span="24">
                        <p class=""><span>配送方式</span>{{orders.transport ==''?'物流配送':orders.transport}}</p>
                    </van-col>
                </van-row>
            </div>
            <p class="item-arrow" @click="showOpen1(3)">{{openText3}}
                <van-icon :name="openIcon3"/>
            </p>
        </div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="peer-pay" class="bg-yellow"/>
                        支付详情
                    </h5>
                </van-col>
            </van-row>
            <div class="item-body-warp" :class="{'open':isOpen4}" v-for="(item, index) in orderPay">
                <van-row>
                    <van-col span="12">
                        <p>序号</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right">{{item.id}}</p>
                    </van-col>
                    <van-col span="12">
                        <p>支付状态</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right green">{{item.pay_status_name}}</p>
                    </van-col>
                    <van-col span="12">
                        <p>支付时间</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right">{{item.pay_time}}</p>
                    </van-col>
                    <van-col span="12">
                        <p>银行交易号</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right">{{item.bank_deal_num}}</p>
                    </van-col>

                </van-row>
                <b class="line"></b>
                <van-row>
                    <van-col span="12">
                        <p><span>支付大类</span>{{item.pay_class_name}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>支付小类</span>{{item.pay_child_class_name}}</p>
                    </van-col>
                    <van-col span="12">
                        <p><span>订单原始总金额</span>￥{{orders.totalPrice}}</p>
                    </van-col>
                    <van-col span="12">
                        <p class="text-right"><span>实际应付金额</span>￥{{item.actual_pay_amount}}</p>
                    </van-col>
                    <van-col span="24" v-if="item.pay_class==5">
                        <p class="text-left" v-if="item.pay_image==null"><span>支付凭证</span>未上传支付凭证</p>
                        <p class="text-left" v-else><span>支付凭证</span><a
                                @click="downFileImg()">查看支付凭证</a>

                            <van-dialog
                                    v-model="picimgeshow"
                            >
                                <img :src="item.pay_image_url" style="width:100%; height:auto;">
                            </van-dialog>
                        </p>
                    </van-col>
                </van-row>
            </div>
            <p class="item-arrow" @click="showOpen1(4)">{{openText4}}
                <van-icon :name="openIcon4"/>
            </p>
        </div>

        <div class="appr-item" v-if="lineOrders!=null">
            <van-row class="appr-item-head">
                <van-col span="24" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="orders-o" class="bg-green"/>
                        线下支付流水号关联订单
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>
            <div class="item-body-warp" :class="{'open':isOpen6}">
                <van-row v-for="item in lineOrders">
                    <van-col span="24">
                        <p class="text-left"><span>订单号：<a @click="lineOrdersDetail(item)">{{item.orderId}}</a> </span>
                        </p>
                    </van-col>
                    <van-col span="24">
                        <p class="text-left"><span>订单提交时间：{{item.createtime}}</span></p>
                    </van-col>
                    <van-col span="24">
                        <p class="text-left"><span>订单状态：{{item.orderStatusName}}</span></p>
                    </van-col>
                    <van-col span="24">
                        <p class="text-left"><span>订单金额</span>￥{{item.realPrice}}</p>
                    </van-col>
                </van-row>
                <van-col span="24">
                    <p class="text-left"><span>实际应付金额</span>￥{{data.shouldPayAmountTotal}}</p>
                </van-col>
            </div>
            <p class="item-arrow" @click="showOpen1(6)">{{openText6}}
                <van-icon :name="openIcon6"/>
            </p>
        </div>

        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="description" class="bg-purple"/>
                        发票信息
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>

            <div class="item-body-warp" :class="{'open':isOpen5}">
                <van-row>
                    <van-col span="14">
                        <p><span>是否开票</span>{{orders.isInvoice == 0?'否':'是'}}</p>
                    </van-col>
                    <van-col span="10">
                        <!-- <p class="text-right"><span>发票类型</span>{{orders.invoiceType}}</p> -->
                        <p class="text-right" v-if="orders.invoiceType == 0">
                            <span>发票类型</span>个人
                        </p>
                        <p v-else-if="orders.invoiceType == 1">
                            <span>发票类型</span>单位
                        </p>
                        <p v-else>
                            <span>发票类型</span>不开发票
                        </p>
                    </van-col>
                    <van-col span="24" v-if="orders.invoiceType == 1">
                        <p><span>发票抬头</span>{{orders.invoice}}</p>
                        <p><span>纳税人识别号</span>{{orders.invoiceIdCode}}</p>
                        <p><span>注册地址</span>{{orders.regAddress}}</p>
                        <p><span>注册电话</span>{{orders.regPhone}}</p>
                        <p><span>开户行</span>{{orders.openBank}}</p>
                        <p><span>银行账号</span>{{orders.openAccount}}</p>
                    </van-col>
                    <van-col span="11">
                        <p><span>手机号</span>{{orders.mobile}}</p>
                    </van-col>
                    <van-col span="13">
                        <p class="text-right"><span>邮箱</span>{{orders.email}}</p>
                    </van-col>
                </van-row>
            </div>
            <p class="item-arrow" @click="showOpen1(5)">{{openText5}}
                <van-icon :name="openIcon5"/>
            </p>
        </div>
        <div class="appr-item">
            <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                    <h5>
                        <van-icon name="orders-o" class="bg-green"/>
                        订单备注
                    </h5>
                </van-col>
                <van-col span="12">
                </van-col>
            </van-row>
            <van-row>
                <van-col span="24">
                    <p><span>备注信息:</span><br/>{{orders.remarks}}</p>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
    import {Dialog,NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Tabs, Tab, Switch} from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Switch.name]: Switch
        },
        data() {
            return {
                activeNames: ["1"],
                checked: true,
                tabActive: 0,
                isOpen1: false,
                openText1: "展开",
                openIcon1: "arrow-down",
                isOpen2: false,
                openText2: "展开",
                openIcon2: "arrow-down",
                isOpen3: false,
                openText3: "展开",
                openIcon3: "arrow-down",
                isOpen4: false,
                openText4: "展开",
                openIcon4: "arrow-down",
                isOpen5: false,
                openText5: "展开",
                openIcon5: "arrow-down",
                isOpen6: false,
                openText6: "展开",
                openIcon6: "arrow-down",
                orders: {},
                appUsers: {},
                workFlow: {},
                orderPay: [],
                curdata: JSON.parse(localStorage.getItem("curdata")),
                data: {},
                lineOrders: [],
                tp: '',
                picimgeshow:false
            };
        },
        mounted() {
            localStorage.setItem("sumPrice", 0)
            localStorage.setItem("resultCheck", JSON.stringify([]))
            let that = this;
           /* var orderid = localStorage.getItem("workflow_id");
            this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': true},
                successRes => {
                    if (successRes.success) {
                        that.data = successRes.data
                        that.orders = successRes.data.orders;
                        that.appUsers = successRes.data.appUser;
                        that.workFlow = successRes.data.workFlow;
                        that.orderPay = successRes.data.orderPayLogs;
                        that.lineOrders = successRes.data.lineOrders
                    }
                })*/
            that.data = JSON.parse(localStorage.getItem('approvalData'))
            that.orders = that.data.orders;
            that.appUsers = that.data.appUser;
            that.workFlow = that.data.workFlow;
            that.orderPay = that.data.orderPayLogs;
            that.lineOrders = that.data.lineOrders
        },
        methods: {
            lineOrdersDetail(obj) {
                localStorage.setItem("workflow_id", obj.workflowId);
                localStorage.setItem("curdata", JSON.stringify(obj));
                localStorage.setItem("curdataAlready", JSON.stringify(obj));
                localStorage.setItem('actionStatus', true);
                location.reload()
            },
            downFileImg() {
                //this.downloadIamge(url + id, 'pic')
                this.picimgeshow=true
            },
           /* downloadIamge(imgsrc, name) {//下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function () {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name || "photo"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },*/
            back() {
                history.back();
            },
            showOpen1(i) {
                switch (i) {
                    case 1:
                        this.isOpen1 = !this.isOpen1;
                        this.openText1 = this.isOpen1 ? '收起' : '展开';
                        this.openIcon1 = this.isOpen1 ? 'arrow-up' : 'arrow-down';
                        break;
                    case 2:
                        this.isOpen2 = !this.isOpen2;
                        this.openText2 = this.isOpen2 ? '收起' : '展开';
                        this.openIcon2 = this.isOpen2 ? 'arrow-up' : 'arrow-down';
                        break;
                    case 3:
                        this.isOpen3 = !this.isOpen3;
                        this.openText3 = this.isOpen3 ? '收起' : '展开';
                        this.openIcon3 = this.isOpen3 ? 'arrow-up' : 'arrow-down';
                        break;
                    case 4:
                        this.isOpen4 = !this.isOpen4;
                        this.openText4 = this.isOpen4 ? '收起' : '展开';
                        this.openIcon4 = this.isOpen4 ? 'arrow-up' : 'arrow-down';
                        break;
                    case 5:
                        this.isOpen5 = !this.isOpen5;
                        this.openText5 = this.isOpen5 ? '收起' : '展开';
                        this.openIcon5 = this.isOpen5 ? 'arrow-up' : 'arrow-down';
                        break;
                    case 6:
                        this.isOpen6 = !this.isOpen6;
                        this.openText6 = this.isOpen6 ? '收起' : '展开';
                        this.openIcon6 = this.isOpen6 ? 'arrow-up' : 'arrow-down';
                        break;
                }
            }
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    body {
        background: #f7f7ff;
    }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 80px;
        left: -10px;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-warphd {

        /*.van-icon {
            color: @bule-thame;
        }*/
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;
            h5 {
                font-size: 16px;
                padding-bottom: 10px;
                i {
                    padding: 5px;
                    background-color: @bule-thame;
                    color: #fff;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }
            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
            .item-arrow {
                border-top: 1px solid #f7f7f7;
                text-align: center;
                color: @bule-thame;
            }
            .line {
                display: block;
                border-bottom: 1px solid #f7f7f7;
            }
        }

        .pro-body {
            padding: 10px;
            .pro-item {
                margin-bottom: 10px;
                background-color: #fff;
                padding: 10px;
                h5 {
                    font-size: 14px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #f7f7f7;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
                p {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-by {
                    padding: 10px 0 0;
                }
                &-ft {
                    background-color: #f7f7f7;
                    padding: 10px;
                }
                .pro-edit {
                    color: @bule-thame;
                    text-decoration: underline;
                    i {
                        vertical-align: -2px;
                    }
                }
            }
        }
        .pay-by {
            padding: 10px;
            .pay-item {
                background-color: #fff;
                padding: 10px;
                position: relative;
                margin-bottom: 10px;
                p {
                    color: #ccc;
                    font-size: 12px;
                    padding: 5px 0;
                }
                &-ft {
                    padding-top: 10px;
                    p {
                        color: #333;
                    }
                }
                .pay-state {
                    text-align: right;
                    color: @bule-thame;
                    i {
                        display: inline-block;
                        padding: 5px;
                        border-radius: 100%;
                        background-color: @bule-thame;
                    }
                }
                &-rd {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 10px;
                    height: 100%;
                    background-color: @bule-thame;
                    border-radius: 10px 0 0 10px;
                }

                &.ok {
                    .pay-state {
                        color: #28a745;
                        i {
                            background-color: #28a745;
                        }
                    }
                    .pay-item-rd {
                        background-color: #28a745;
                    }
                }
                &.err {
                    .pay-state {
                        color: #ffc107;
                        i {
                            background-color: #ffc107;
                        }
                    }
                    .pay-item-rd {
                        background-color: #ffc107;
                    }
                }
            }
        }
        .pay-hd-item {
            margin-bottom: 10px;
            .pay-hd-line {
                border-bottom: 1px solid #f7f7f7;
                margin-bottom: 10px;
            }
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }

        .van-cell:not(:last-child)::after {
            border: none;
        }

        .apply {
            .van-field {
                margin: 10px 0;
                border: 1px solid #f7f7f7;
            }
            .van-col--8 {
                padding: 0 10px;
            }
            button {
                font-size: 14px;
                height: 40px;
                line-height: 38px;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
            button.danger {
                background-color: #ffc107;
                border-color: #ffc107;
            }
        }

        .item-body-warp {
            height: 60px;
            overflow: hidden;
            position: relative;
        }
        .item-body-warp.open {
            height: auto;
        }
    }
</style>
